export default function ClickCease() {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
              var script = document.createElement('script');
              script.async = true; script.type = 'text/javascript';
              var target = 'https://www.clickcease.com/monitor/stat.js';
              script.src = target;var elem = document.head;elem.appendChild(script);
        `,
        }}
      />
      <noscript>
        <a href="https://www.clickcease.com" rel="nofollow">
          {/* eslint-disable-next-line hydrogen/prefer-image-component */}
          <img
            src="https://monitor.clickcease.com/stats/stats.aspx"
            alt="ClickCease"
          />
        </a>
      </noscript>
    </>
  );
}
